// 苏迪曼杯顶部菜单

module.exports = {
  sportType: 'badminton',
  menuData: [
    {
      name: 'webMenu',
      arr: [
        {
          name: '赛程',
          key: 'schedule',
          routeName: 'badmintonScheduleIndex_BDMSC',
          act: true,
        },
        {
          name: '积分榜',
          key: 'leagueTable',
          routeName: 'badmintonLeagueTableIndex_BDMSC',
          act: false,
        },
        {
          name: '淘汰赛',
          key: 'knockoutRounds',
          routeName: 'badmintonKnockoutRoundsIndex_BDMSC',
          act: false,
        },
        {
          name: '晋级之路',
          key: 'eventsThemeList',
          routeName: 'badmintonEventsThemeListIndex_BDMSC',
          act: false,
        },
        //   {
        //     name: '赛程',
        //     key: 'schedule',
        //     routeName: 'badmintonScheduleIndex_BDMSC',
        //     act: true,
        //     child: [
        //       {
        //         name: '常规赛程',
        //         key: 'regularSchedule',
        //         routeName: 'badmintonRegularScheduleIndex_BDMSC',
        //         act: false,
        //       },
        //       {
        //         name: '运动员赛程',
        //         key: 'playersSchedule',
        //         act: false,
        //         routeName: 'badmintonEventPlayersScheduleIndex_BDMSC',
        //       },
        //     ],
        //   },
        //   {
        //     name: '项目',
        //     key: 'bigSports',
        //     routeName: 'badmintonBigSportsIndex_BDMSC',
        //     act: false,
        //   },
        //   {
        //     name: '奖牌',
        //     key: 'medal',
        //     routeName: 'badmintonMedalIndex_BDMSC',
        //     act: false,
        //     child: [
        //       {
        //         name: '奖牌榜',
        //         key: 'medalTally',
        //         routeName: 'badmintonMedalTallyIndex_BDMSC',
        //         act: false,
        //       },
        //       {
        //         name: '奖牌明细',
        //         key: 'medalDetailList',
        //         act: false,
        //         routeName: 'badmintonMedalDetailListIndex_BDMSC',
        //       },
        //     ],
        //   },
        //   {
        //     name: '代表团',
        //     key: 'delegation',
        //     routeName: 'badmintonDelegationIndex_BDMSC',
        //     act: false,
        //   },
        //   {
        //     name: '运动员',
        //     key: 'player',
        //     routeName: 'badmintonPlayerIndex_BDMSC',
        //     act: false,
        //   },
        //   {
        //     name: '纪录',
        //     key: 'record',
        //     routeName: 'badmintonRecordIndex_BDMSC',
        //     act: false,
        //   },
        //   {
        //     name: '场馆',
        //     key: 'venue',
        //     routeName: 'badmintonVenueIndex_BDMSC',
        //     act: false,
        //   },
      ],
    },
    {
      name: 'openMenu',
      arr: [
        {
          name: '节目单',
          key: 'programList',
          routeName: 'badmintonProgramListIndex_BDMSC',
          act: false,
          isOpenWeb: true,
        },
        {
          name: '播出单',
          key: 'broadcastList',
          routeName: 'badmintonBroadcastListIndex_BDMSC',
          act: false,
          isOpenWeb: true,
        },
        {
          name: '数据包装',
          key: 'dataPackagList',
          routeName: 'badmintonDataPackagListIndex_BDMSC',
          act: false,
          isOpenWeb: true,
        },
      ],
    },
  ],
}
